import { EMPTY_ARRAY, IApplicationState } from '../../../../../../../types/types';
import { IGoogleDrive } from '../../types';

export const getDrives = (
    state: IApplicationState
): IGoogleDrive[] => {
    return state.openBoardsDialog && state.openBoardsDialog.drives && state.openBoardsDialog.drives.drives || EMPTY_ARRAY;
}
